import { restApiRP } from "@plannel/services/utils/rest-api";

const getAll = params => {
  return restApiRP.post("/api/rp-order-list", params);
}

const getAllForCSV = params => {
  return restApiRP.post("/api/rp-order-list/csv", params);
}

const rpOrderListService = {
  getAll,
  getAllForCSV
};

export default rpOrderListService;